import PropTypes from 'prop-types';
import React from "react";
import {connect} from "react-redux";
import ReactDOM from 'react-dom';
import {Button, Grid, Col, Row, DropdownButton, MenuItem, Checkbox, FormControl, FormGroup, ControlLabel, Form} from "react-bootstrap";
import {validateEmail, validateZipCode, isValidPhoneNumber, isEmptyString, geocodeAddress, isEmptyObj} from "../../common/utils";
import StatesData from "../../common/statesData";
import {URLs, INVALID_SEND_EMAIL_PARTNER_MESSAGE, FetchingTypes, MemberActions, JoinSteps, PickupSiteTypes, GEOCODE_ERROR} from "../../common/constants";
import {setDirty} from '../../actions/common/commonActions';
import {setMemberData, updateMember, setMemberAction,setUpdateMemberError, setShowPassword, setAddressValidationError, setAddressValidationErrorNoAction} from "../../actions/login/memberDetailsActions";
import {MANDATORY_MEMBER_FIELDS, MEMBER_FIELDS_NO_FB, MEMBER_ERROR_VALIDATION_MESSAGE, NOT_MANDATORY_MEMBER_FIELDS} from "../../common/contactDetailsConstants";
import {getWaitlistItems} from "../../common/basket";
import {translate} from '../../i18n/translate.js';
import {errorFetching, isFetching} from "../../actions/common/fetchingActions";
import {sendCancelSubscriptionRequest} from "../../actions/account/accountActions";
import styles from "../../css/contactDetailsForm.less";

class ContactDetailsForm extends React.Component {
    constructor(props) {
        super(props);
        const states = props.farmCountry==='CA'?StatesData.CA:StatesData.US;
        let memberDetails = Object.assign({}, props.memberDetails, {});
        memberDetails['state'] = !memberDetails.state ? props.farmState: memberDetails.state;
        this.addressErrorCounter = 0;

        this.state = {
            states: states,
            memberDetails,
            contactValidation: {},
            enableToContinue: false
        };
    }

    componentWillMount() {
      if(!this.props.memberDetails.key && !this.props.showPassword) {
          this.props.setShowPassword(true);
      }
    }

    updateField = (fieldName, fieldValue) => {
        const memberDetails = this.state.memberDetails;
        memberDetails[fieldName] = fieldValue;
        this.setState({memberDetails, enableToContinue: true});
        if(!this.props.isDirty) {
            this.props.setDirty(true);
        }
    };

    handleFieldValidation = (isValid, errorFieldName, errorMessage, contactValidation) => {
        if(!isValid) {
            contactValidation[errorFieldName] = errorMessage;
        } else {
            contactValidation[errorFieldName] = undefined;
        }
    };

    validateEmail = (email) => {
        return validateEmail(email);
    };

    validatePassword = (password) => {
        return password.length > 5;
    };

    validateRetypedPassword = (retypedPassword) => {
        return retypedPassword === this.state.memberDetails.password;
    };

    validateLastName = (lastName) => {
      return !isEmptyString(lastName);
    };

    validateFirstName = (firstName) => {
        return !isEmptyString(firstName);
    };

    handleStateChange = (value) => {
        const memberDetails = this.state.memberDetails;
        memberDetails['state'] = value;
        this.props.setMemberData(memberDetails);
    };

    validatePrimaryPhone = (primaryPhone) => {
        return !isEmptyString(primaryPhone) && isValidPhoneNumber(primaryPhone);
    };

    validateSecondaryPhone = (secondaryPhone) => {
        if(!isEmptyString(secondaryPhone)) {
            return isValidPhoneNumber(secondaryPhone);
        }
        return true;
    };

    validateAddressLine1 = (addressLine1) => {
        return !isEmptyString(addressLine1);
    };

    validateCity = (city) => {
        return !isEmptyString(city);
    };

    validateZipCode = (zipCode) => {
        return validateZipCode(zipCode, this.props.farmCountry) && !isEmptyString(zipCode);
    };

    validatePartnerEmail = (partnerEmail) => {
        if(!isEmptyString(partnerEmail)) {
            return validateEmail(partnerEmail);
        }
        return true;
    };

    validatePartnerPhone = (partnerPhone) => {
        if(!isEmptyString(partnerPhone)) {
            return isValidPhoneNumber(partnerPhone);
        }
        return true
    };

    handleSendPartnerEmailsChange = (event) => {
      this.updateField("sendPartnerEmails", event.target.checked);
    };

    handleReceiveEmailsRemindersChange = (event) => {
        this.updateField("recieveEmailsReminders", event.target.checked);
    };

    componentWillReceiveProps(nextProps) {
        if(this.props.memberAction !== nextProps.memberAction && nextProps.memberAction === MemberActions.VALIDATE_MEMBER_DETAILS) {
            this.accountSaveClicked();
        }
        if(nextProps.updateMemberError && this.props.updateMemberError !== nextProps.updateMemberError ){
            const contactValidation = this.state.contactValidation;
            contactValidation.invalidEmail = nextProps.updateMemberError;
            this.setState({contactValidation});
        }
        if (!isEmptyObj(this.state.contactValidation)) {
            for(let key in this.state.contactValidation) {
                if (this.state.contactValidation.hasOwnProperty(key) && this.state.contactValidation[key]) {
                    let fieldName = key.substr(7, key.length-1);
                    fieldName = fieldName.replace(fieldName.charAt(0), fieldName[0].toLowerCase());
                    const dom = ReactDOM.findDOMNode(this.refs[fieldName].refs.frm);
                    dom.scrollIntoView(false);
                    break;
                }
            }
        }
    }

    createStateSelection = () => {
        const inputDetailStyle = " state-selection" + (this.props.clientViewPort.isXs?" mobile":"");
        let states = [];
        for (let id in this.state.states) {
            if (this.state.states.hasOwnProperty(id)) {
                states.push(<MenuItem key={id} eventKey={id}>{this.state.states[id]}</MenuItem>);
            }
        }
        return (<DropdownButton dropup className={"input-detail" + inputDetailStyle} noCaret
                                id="state-selection" onSelect={this.handleStateChange}
                                title={this.state.states[this.state.memberDetails.state]}
                                disabled={this.props.isHomeDelivery && this.props.flowType === URLs.ACCOUNT}>
            {states}
        </DropdownButton>);
    };

    statesSelection = () => {
        const inputDetailsRowStyle = "input-detail-row" + (this.props.clientViewPort.isXs?" input-detail-row-mobile":"");
        const contactValidation = "contact-details-validation" + (!this.props.clientViewPort.isXs?"":" mobile");
        return (<Form className={inputDetailsRowStyle} horizontal>
            <FormGroup controlId={"formHorizontalInputstate"} className="form-group-contact-details">
                <Col componentClass={ControlLabel} sm={4} className="input-detail-lbl">{translate("State")}</Col>
                <Col sm={8} className="input-details-col">
                    {this.createStateSelection()}
                    <div className={contactValidation}>
                        <div className="no-error-input"/>
                    </div>
                </Col>
            </FormGroup>
        </Form>);
    };

    validateFields = (memberFields, contactValidation, mandatory) => {
        let isValid = true;
        for(let memberField in memberFields) {
            if (memberFields.hasOwnProperty(memberField)) {
                const invalidField = 'invalid' + memberField;
                const fieldName = memberField[0].toLowerCase() + memberField.substring(1);
                let errorMessage;
                const value = this.state.memberDetails[fieldName];
                let isValidField = true;
                if (isEmptyString(value) && mandatory) {
                    isValidField = isValid = false;
                    errorMessage = memberFields[memberField];
                } else {
                    if (this.hasOwnProperty("validate" + memberField) && !(this["validate" + memberField](value))) {
                        isValidField = isValid = false;
                        errorMessage = MEMBER_ERROR_VALIDATION_MESSAGE[invalidField];
                    }
                }
                this.handleFieldValidation(isValidField, invalidField, errorMessage, contactValidation);
            }
        }
        return isValid;
    };

    validateErrors = () => {
        const contactValidation = {};
        let isValid = this.validateFields(MANDATORY_MEMBER_FIELDS, contactValidation, true);
        if (!this.state.memberDetails.isFBLogin && this.props.showPassword) {
            if (this.state.invalidPassword || this.state.invalidRetypedPassword) {
                isValid = false;
            }
            isValid = this.validateFields(MEMBER_FIELDS_NO_FB, contactValidation, true) && isValid;
        }
        isValid = this.validateFields(NOT_MANDATORY_MEMBER_FIELDS, contactValidation) && isValid;
        if (this.state.invalidSecondaryPhone || this.state.invalidPartnerEmail || this.state.invalidEmail ||
            this.state.invalidPartnerPhone || this.state.invalidZipCode || this.state.invalidPrimaryPhone ||
            this.state.invalidFirstName || this.state.invalidLastName || this.state.invalidCity) {
            isValid = false;
        }
        let message;
        if(this.state.memberDetails.sendPartnerEmails && (!this.state.memberDetails.partnerLastName ||
            !this.state.memberDetails.partnerFirstName || !this.state.memberDetails.partnerEmail)) {
            isValid = false;
            message = INVALID_SEND_EMAIL_PARTNER_MESSAGE;
            contactValidation.invalidPartnerEmail= " ";
            contactValidation.invalidPartnerFirstName = " ";
            contactValidation.invalidPartnerLastName = " ";
        }
        contactValidation.invalidSendPartnerEmail = message;
        this.setState({contactValidation});
        return isValid;
    };

    invalidAddressHandler = () => {
        this.state.memberDetails.lat = null;
        this.state.memberDetails.lng = null;
        const contactValidation = this.state.contactValidation;
        if (!this.props.isHomeDelivery) {
            contactValidation.invalidZipCode = translate('_AddressError');
            contactValidation.invalidCity = translate('_AddressError');
            this.props.setAddressValidationError(contactValidation.invalidZipCode);
            //Temp reporting of error
        } else {
            contactValidation.invalidAddressLine1 = translate('_AddressError');
            this.props.setAddressValidationError(contactValidation.invalidAddressLine1);
        }
        this.setState({contactValidation: contactValidation});
    };

    validateAddress = (delay) => {
        let address = "";
        if(this.props.isHomeDelivery) {
            address = this.state.memberDetails.addressLine1 + " ";
        }
        address += this.state.memberDetails.city + " " + this.state.memberDetails.state + " " + this.state.memberDetails.zipCode;
        return geocodeAddress(address, delay).then(geoCode => {
            switch(geoCode.status) {
                case google.maps.GeocoderStatus.OK: {
                    this.state.memberDetails.lat = geoCode.lat;
                    this.state.memberDetails.lng = geoCode.lng;
                    return true;
                }
                case google.maps.GeocoderStatus.ZERO_RESULTS: {
                    this.invalidAddressHandler();
                    return false;
                }
                default:
                    throw geoCode;
            }
        }).catch(error => {
            if (this.addressErrorCounter < 5) {
                this.addressErrorCounter += 1;
                this.props.setAddressValidationErrorNoAction(error);
                return this.validateAddress(2000);
            } else {
                throw Error(GEOCODE_ERROR);
            }
        });
    };

    validateContactDetails = () => {
        const isValid = this.validateErrors();
        if (isValid) {
            this.validateAddress().then(isValid => {
                if (isValid) {
                    this.props.setMemberData(this.state.memberDetails);
                    if (!isEmptyObj(this.props.signupData) && this.props.signupData.steps) {
                        let index = this.props.signupData.steps.indexOf(JoinSteps.CONTACT_INFO);
                        let isWaitListOnly = (this.props.signupData.data || {}).isWaitListOnly;
                        let waitListItems = !isWaitListOnly ? null : getWaitlistItems(this.props.signupData.sharesData.shares);
                        let step = this.props.signupData.steps[++index];
                        this.props.updateMember(this.state.memberDetails, step ? step : JoinSteps.THANK_YOU, waitListItems);
                    } else {
                        this.props.setDirty(false);
                        this.props.updateMember(this.state.memberDetails, URLs.ACCOUNT);
                    }
                    this.props.setShowPassword(false);
                }
                if (this.props.clientViewPort.isXs)
                    window.scrollTo(0, 0);
                this.props.setMemberAction(MemberActions.NO_ACTION);
                this.props.setUpdateMemberError(null);
            }).catch(error => {
                this.props.setDirty(false);
                this.props.errorFetching(error);
            });
        } else {
            this.props.setMemberAction(MemberActions.NO_ACTION);
            this.props.setUpdateMemberError(null);
        }
    };

    getPasswordFields = () => {
        if((!this.state.memberDetails.isFBLogin && !this.state.memberDetails.key) || this.props.showPassword) {
            return (<div>
                <InfoDetail value={this.state.memberDetails.password} type="password" label="Choose a Password" ref="password"
                            update={this.updateField} errorValue={this.state.contactValidation.invalidPassword}
                            fieldName="password" isXs={this.props.clientViewPort.isXs}/>
                <InfoDetail value={this.state.memberDetails.retypedPassword} type="password" label="Retype Password" ref="retypedPassword"
                            update={this.updateField} errorValue={this.state.contactValidation.invalidRetypedPassword}
                            fieldName="retypedPassword" isXs={this.props.clientViewPort.isXs}/>
            </div>)
        } else if(!this.state.memberDetails.isFBLogin) {
            if(this.props.clientViewPort.isXs) {
                return (<Form className="input-detail-row input-detail-row-mobile" horizontal>
                    <FormGroup className="form-group-contact-details change-password" controlId={"formHorizontalChangePasswordMobile"}>
                        <Col xs={3} className="input-details-col"><label className="input-detail-lbl">{translate("Password")}</label></Col>
                        <Col xs={3} className="input-details-col"><div className="changePasswordLink" onClick={this.onClickChangePassword}>{translate("Change")}</div></Col>
                    </FormGroup>
                </Form>);
            } else {
                return (<Form className="input-detail-row" horizontal>
                    <FormGroup className="form-group-contact-details form-group-change-password" controlId={"formHorizontalChangePassword"}>
                        <Col componentClass={ControlLabel} sm={4} className="input-detail-lbl">{translate("Password")}</Col>
                        <Col sm={8} className="input-details-col">
                            <div className="changePasswordLink"><div onClick={this.onClickChangePassword}>{translate("Change")}</div></div>
                        </Col>
                    </FormGroup>
                </Form>);
            }
        }
    };

    getTitleHeader = () => {
        if (this.props.clientViewPort.isXs && this.props.flowType !== URLs.ACCOUNT) {
            return null;
        } else {
            return (<Row className="contact-details-header-title account-header-title-container">
                {
                    this.props.clientViewPort.isXs ?
                        <div className="account-header-title">{translate("My Contact Information")}</div>:
                        <div className="email-img-contact-form-title">
                            <span className="email-img"/>
                            {translate(!this.state.memberDetails.key ? "_enterContactInfo" : "Your contact information")}
                        </div>
                }
                {
                    this.props.flowType === URLs.ACCOUNT ?
                        <Button disabled={!this.state.enableToContinue}
                                onClick={this.accountSaveClicked}
                                type="submit"
                                className={"submit-order button save-contact-btn" + (this.props.showLoading ? " loading" : "")}
                                bsStyle="primary">{translate("Save")}</Button>
                        : undefined
                }
            </Row>);
        }
    };

    onClickChangePassword = () => {
        const memberDetails = this.state.memberDetails;
        memberDetails.password = '';
        memberDetails.retypedPassword = '';
        this.props.setMemberData(memberDetails);
        if(!this.props.isDirty) {
            this.props.setDirty(true);
        }
        this.props.setShowPassword(true);
    };

    accountSaveClicked = () => {
        this.validateContactDetails(this.state.memberDetails, true);
        this.setState({enableToContinue: false});
    };

    sendCancelSubscriptionRequest = () => {
        this.props.sendCancelSubscriptionRequest();
    };

    render() {
        const innerContainerStyle = "inner-container-join" + (this.props.clientViewPort.isXs ? " inner-container-join-mobile" : "");
        const separatorLineStyle = "create-contact-line" + (this.props.clientViewPort.isXs ? " create-contact-line-mobile" : "");
        const inputDetailsRowStyle = "input-detail-row" + (this.props.clientViewPort.isXs ? " input-detail-row-mobile" : "");
        const primaryPhoneLabel = this.props.showCellPhoneLabels ? 'Primary Cell Phone*' : 'Primary Phone';
        return (<Grid className="border-container border-container-join">
                {this.getTitleHeader()}
                <Row className={innerContainerStyle}>
                    <Row className="form-container contact-details-container" disabled={this.props.showLoading}>
                        <fieldset disabled={this.props.showLoading || this.props.isPreview || this.props.memberAction === MemberActions.VALIDATE_MEMBER_DETAILS}>
                            <Row>
                                <Col md={6} className="contact-details-left">
                                    <InfoDetail value={this.state.memberDetails.email} type="email"
                                                label="Email Address" ref="email"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidEmail} fieldName="email"
                                                isXs={this.props.clientViewPort.isXs}/>
                                    {this.getPasswordFields()}
                                    <InfoDetail value={this.state.memberDetails.firstName} type="text"
                                                label="First Name" ref="firstName"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidFirstName}
                                                fieldName="firstName"
                                                isXs={this.props.clientViewPort.isXs}
                                                style="name-input"/>
                                    <InfoDetail value={this.state.memberDetails.lastName} type="text" label="Last Name"
                                                ref="lastName"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidLastName}
                                                fieldName="lastName"
                                                isXs={this.props.clientViewPort.isXs}
                                                style="name-input"/>
                                    <InfoDetail value={this.state.memberDetails.primaryPhone} type="text"
                                                label={primaryPhoneLabel} ref="primaryPhone"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidPrimaryPhone}
                                                fieldName="primaryPhone"
                                                isXs={this.props.clientViewPort.isXs}/>
                                    <InfoDetail value={this.state.memberDetails.secondaryPhone} type="text"
                                                label="Secondary Phone" ref="secondaryPhone"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidSecondaryPhone}
                                                fieldName="secondaryPhone"
                                                isXs={this.props.clientViewPort.isXs}/>
                                    {
                                        this.props.flowType === URLs.ACCOUNT ?
                                            <Form inline className={inputDetailsRowStyle+ " contact-cbk"}>
                                                    <Checkbox className="input-detail-cbx"
                                                              checked={this.state.memberDetails.recieveEmailsReminders}
                                                              onChange={this.handleReceiveEmailsRemindersChange}
                                                              ref="receiveEmailsReminders">
                                                        <div className="input-detail-cbk-lbl">{translate("_receiveReminders")}</div>
                                                    </Checkbox>
                                            </Form> : undefined
                                    }
                                </Col>
                                <Col md={6} className="contact-details-right">
                                    <InfoDetail value={this.state.memberDetails.addressLine1} type="text"
                                                label="Address Line 1" ref="addressLine1"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidAddressLine1}
                                                disabled={this.props.isHomeDelivery && this.props.flowType === URLs.ACCOUNT} fieldName="addressLine1"
                                                isXs={this.props.clientViewPort.isXs}/>
                                    <InfoDetail value={this.state.memberDetails.addressLine2} type="text"
                                                label="Address Line 2" ref="addressLine2"
                                                update={this.updateField} fieldName="addressLine2"
                                                disabled={this.props.isHomeDelivery && this.props.flowType === URLs.ACCOUNT}
                                                isXs={this.props.clientViewPort.isXs}/>
                                    <InfoDetail value={this.state.memberDetails.city} type="text" label="City"
                                                ref="city"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidCity}
                                                disabled={this.props.isHomeDelivery && this.props.flowType === URLs.ACCOUNT} fieldName="city"
                                                isXs={this.props.clientViewPort.isXs}
                                                style="name-input"/>
                                    {this.statesSelection()}
                                    <InfoDetail value={this.state.memberDetails.zipCode} type="text"
                                                label="Zip/Postal Code" ref="zipCode"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidZipCode}
                                                fieldName="zipCode"
                                                disabled={this.props.isHomeDelivery && this.props.flowType === URLs.ACCOUNT}
                                                isXs={this.props.clientViewPort.isXs}/>
                                </Col>
                            </Row>
                            {this.props.showCellPhoneLabels &&
                                <Row className={inputDetailsRowStyle + " form-inline"}>* {this.props.showCellPhoneLabels}</Row>
                            }
                            <Row className={separatorLineStyle}/>
                            <Row>
                                <Col md={6} className="additional-contact-details-lbl">
                                    {translate("Additional Contact")}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="contact-details-left">
                                    <InfoDetail value={this.state.memberDetails.partnerFirstName} type="text"
                                                label="First Name" ref="partnerFirstName"
                                                update={this.updateField} fieldName="partnerFirstName"
                                                errorValue={this.state.contactValidation.invalidPartnerFirstName}
                                                isXs={this.props.clientViewPort.isXs}
                                                style="name-input"/>
                                    <InfoDetail value={this.state.memberDetails.partnerLastName} type="text"
                                                label="Last Name" ref="partnerLastName"
                                                update={this.updateField} fieldName="partnerLastName"
                                                errorValue={this.state.contactValidation.invalidPartnerLastName}
                                                isXs={this.props.clientViewPort.isXs}
                                                style="name-input"/>
                                </Col>
                                <Col md={6} className="contact-details-right">
                                    <InfoDetail value={this.state.memberDetails.partnerEmail} type="email"
                                                label="Email Address" ref="partnerEmail"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidPartnerEmail}
                                                fieldName="partnerEmail"
                                                isXs={this.props.clientViewPort.isXs}/>
                                    <InfoDetail value={this.state.memberDetails.partnerPhone} type="text" label="Phone"
                                                ref="partnerPhone"
                                                update={this.updateField}
                                                errorValue={this.state.contactValidation.invalidPartnerPhone}
                                                fieldName="partnerPhone" isXs={this.props.clientViewPort.isXs}
                                                />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8} className="contact-details-left">
                                    <Form inline className={inputDetailsRowStyle + " contact-cbk"}>
                                        <Checkbox className="input-detail-cbx"
                                                  checked={this.state.memberDetails.sendPartnerEmails}
                                                  onChange={this.handleSendPartnerEmailsChange}
                                                  ref="sendPartnerEmails">
                                            <div className="input-detail-cbk-lbl">{translate("alsoSendComEmail")}</div>
                                        </Checkbox>
                                        {
                                            this.state.contactValidation.invalidSendPartnerEmail ?
                                                <div
                                                    className="validation-error send-email-error">{this.state.contactValidation.invalidSendPartnerEmail}</div>
                                                : undefined
                                        }
                                    </Form>
                                </Col>
                            </Row>
                        </fieldset>
                    </Row>
                </Row>
            {(this.props.showSendCancelSubscriptionRequest) &&
                <Row>
                    <Col md={8}>
                        <div className="cancel-request-link" onClick={this.sendCancelSubscriptionRequest}>
                            Request to Cancel Subscription
                        </div>
                    </Col>
                </Row>}
            </Grid>);
    }
}

class InfoDetail extends React.Component {
    onChangeField(event) {
        this.props.update(this.props.fieldName, event.target.value);
    }
    render() {
        const inputDetailsRowStyle = "input-detail-row" + (this.props.isXs?" input-detail-row-mobile":"");
        const styleClass = "input-detail" + (this.props.style?" " + this.props.style:"") +(!this.props.errorValue ?"":" error");
        const contactValidation = "contact-details-validation" + (!this.props.isXs?"":" mobile");
        const errorStyle = "contact-details-validation-error" + (!this.props.isXs?"":" mobile");
        return (<Form className={inputDetailsRowStyle} horizontal ref="frm">
            <FormGroup controlId={"formHorizontalInput" + this.props.fieldName} className="form-group-contact-details">
                <Col componentClass={ControlLabel} sm={4} className="input-detail-lbl" ref="lbl">
                    {translate(this.props.label)}</Col>
                <Col sm={8} className="input-details-col">
                    <FormControl className={styleClass} type={this.props.type}
                                 value={this.props.value ? this.props.value : ''}
                                 disabled={this.props.disabled}
                                 ref="inp" onChange={this.onChangeField.bind(this)}/>
                    <div className={contactValidation}>
                    {
                        this.props.errorValue && this.props.errorValue !== " "?
                            <div className={"validation-error " + errorStyle}>{this.props.errorValue}</div>
                            : <div className="no-error-input"/>
                    }
                    </div>
                </Col>
            </FormGroup>
        </Form>);
    }
}

InfoDetail.propTypes = {
    update: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["text", "email", "password"]),
    value: PropTypes.string,
    errorValue: PropTypes.string,
    fieldName: PropTypes.string.isRequired
};


const mapStateToProps = (state) => {
    const memberDetails = (state.memberDetails || {});
    const summary = (state.summary || {});
    const pickupSiteType = (summary.pickupSite|| {}).type;
    const isHomeDelivery= pickupSiteType === PickupSiteTypes.HOME || pickupSiteType === PickupSiteTypes.ZONE;
    return {
        clientViewPort: (state.clientViewPort || {}),
        memberDetails: memberDetails,
        showPassword: memberDetails.showPassword,
        updateMemberError: memberDetails.updateMemberError,
        farmState: state.staticData.farmState,
        farmCountry: state.staticData.farmCountry,
        showLoading: isFetching(state, FetchingTypes.VALIDATE_UPDATE_MEMBER),
        memberAction: memberDetails.memberAction,
        signupData: state.signupData,
        isHomeDelivery: isHomeDelivery,
        isPreview: (state.staticData || {}).isPreview,
        isDirty: (state.orderStatus || {}).isChanged,
        showCellPhoneLabels: state.staticData.contactInfoShowCellPhoneLabels,
        showSendCancelSubscriptionRequest: state.staticData.allowMemberToSendCancelSubscriptionRequest && !(state.signupData && state.signupData.data)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMemberData: (member) => {
            dispatch(setMemberData(member))
        },
        setDirty: (isDirty) => {
            dispatch(setDirty(isDirty));
        },
        setUpdateMemberError: (updateMemberError) => {
            dispatch(setUpdateMemberError(updateMemberError));
        },
        setShowPassword: (showPassword) => {
            dispatch(setShowPassword(showPassword));
        },
        updateMember: (contactDetails, step, waitListItems) => {
            dispatch(updateMember(contactDetails, step, waitListItems));
        },
        setMemberAction: (memberAction) => {
            dispatch(setMemberAction(memberAction));
        },
        setAddressValidationError: (error) => {
            dispatch(setAddressValidationError(error));
        },
        setAddressValidationErrorNoAction: (error) => {
            dispatch(setAddressValidationErrorNoAction(error));
        },
        errorFetching: (error) => {
            dispatch(errorFetching(error));
        },
        sendCancelSubscriptionRequest: () => {
            dispatch(sendCancelSubscriptionRequest());
        }
    }
};
export default connect (mapStateToProps, mapDispatchToProps) (ContactDetailsForm);


// WEBPACK FOOTER //
// ./src/components/common/ContactDetailsForm.js